<div class="page" [ngStyle]="{ 'min-height': tabScrollHack }">
  @if (product.headerImageUrl) {
    <div class="background-logo">
      <img [src]="product.headerImageUrl" [srcset]="srcsetHeaderImage" class="bannerImage" />
    </div>
  } @else {
    <div class="background-logo">
      <img [src]="defaultHeaderImage" class="defaultBannerImage" />
    </div>
  }

  <div>
    @if (mobileLayout) {
      <div class="mobile-container">
        <div class="flex-row">
          <div class="icon">
            <va-icon [iconUrl]="product.iconUrl" [iconName]="product.name" [diameter]="60"></va-icon>
          </div>
          <div class="centered-column">
            <div class="title">{{ product.name }}</div>
            <div class="tag-line">{{ product.tagline }}</div>
          </div>
        </div>
        <div class="mobile-chip-container">
          <mat-chip-listbox>
            <div class="flex-row">
              <div id="chipStart"></div>
              <div class="chip-list">
                @for (chip of chipLabels; track chip) {
                  <mat-chip-option class="chipItem">
                    {{ chip }}
                  </mat-chip-option>
                }
              </div>
              <div class="more-chip-spacer">
                @if (showMoreChip) {
                  <mat-chip-option
                    [matTooltip]="overflowTagsList"
                    (mouseenter)="$event.stopImmediatePropagation()"
                    (mouseleave)="$event.stopImmediatePropagation()"
                    #tooltip="matTooltip"
                    (click)="tooltip.toggle()"
                    class="more-chip"
                    [ngStyle]="{ left: moreChipPosition }"
                    >
                    <span [matBadge]="hiddenChipNum" [matBadgeOverlap]="false">
                      {{ onlyMore ? ('FRONTEND.STORE.TAGS' | translate) : ('FRONTEND.STORE.MORE' | translate) }}
                    </span>
                  </mat-chip-option>
                }
              </div>
            </div>
          </mat-chip-listbox>
        </div>
        @if (isHeaderActionUsed || isContactActionUsed) {
          <div class="product-actions-container">
            <span>
              @if (isContactActionUsed) {
                <button mat-stroked-button (click)="contactActionClick.emit()">
                  {{ 'FRONTEND.STORE.CONTACT_US' | translate }}
                </button>
              }
            </span>
            <div [glxyTooltip]="getHeaderActionTooltip()">
              @if (isHeaderActionUsed) {
                <button
                  data-action="clicked-product-action-button"
                  class="primary-action-button"
                  mat-flat-button
                  color="primary"
                  [disabled]="isHeaderActionButtonDisabled()"
                  (click)="onHeaderActionClicked()"
                  >
                  <span>{{ getEnableButtonText() }}</span>
                </button>
              }
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="web-container">
        <div class="icon-container">
          <div class="icon">
            <va-icon [iconUrl]="product.iconUrl" [iconName]="product.name" [diameter]="120" id="thing"></va-icon>
          </div>
        </div>
        <div class="web-center-container">
          <div class="web-name-chips-container">
            <div class="title small-gutter">{{ product.name }}</div>
            @if (!this.hideTags) {
              <div class="web-chip-container">
                <mat-chip-listbox>
                  <div class="flex-row">
                    <div id="chipStart"></div>
                    <div class="chip-list">
                      @for (chip of chipLabels; track chip) {
                        <mat-chip-option class="chipItem">
                          {{ chip }}
                        </mat-chip-option>
                      }
                    </div>
                    <div class="more-chip-spacer">
                      @if (showMoreChip) {
                        <mat-chip-option
                          [matMenuTriggerFor]="menu"
                          class="more-chip"
                          [ngStyle]="{ left: moreChipPosition }"
                          >
                          <span [matBadge]="hiddenChipNum" [matBadgeOverlap]="false">
                            {{ onlyMore ? ('FRONTEND.STORE.TAGS' | translate) : ('FRONTEND.STORE.MORE' | translate) }}
                          </span>
                        </mat-chip-option>
                      }
                      <mat-menu #menu="matMenu">
                        @for (tag of moreList; track tag) {
                          <button mat-menu-item>
                            <li>{{ tag }}</li>
                          </button>
                        }
                      </mat-menu>
                    </div>
                  </div>
                </mat-chip-listbox>
              </div>
            }
          </div>
          <div class="tag-line small-gutter">
            {{ product.tagline }}
          </div>
        </div>
        @if (isHeaderActionUsed || isContactActionUsed) {
          <div
            id="web-action-container"
            class="web-product-actions-container"
            >
            <span>
              @if (isContactActionUsed) {
                <button mat-stroked-button (click)="contactActionClick.emit()">
                  {{ 'FRONTEND.STORE.MESSAGE_US' | translate }}
                </button>
              }
            </span>
            <div [glxyTooltip]="getHeaderActionTooltip()">
              @if (isHeaderActionUsed) {
                <button
                  data-action="clicked-product-action-button"
                  class="primary-action-button"
                  mat-flat-button
                  color="primary"
                  [disabled]="isHeaderActionButtonDisabled()"
                  (click)="onHeaderActionClicked()"
                  >
                  <span>{{ getEnableButtonText() }}</span>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }

  </div>
  @if (tabState$ | async; as tabState) {
    <mat-tab-group [selectedIndex]="tabState.tab" (selectedTabChange)="onTabChanged($event)">
      <mat-tab label="{{ 'FRONTEND.STORE.PRODUCT_DETAILS.TAB_LABELS.PRODUCT_INFORMATION' | translate }}">
        <store-product-info
          [product]="product"
          [partnerId]="partnerId"
          [marketId]="marketId"
          [appPrice]="appPrice"
          [addonPrices]="addonPrices"
          [currency]="currency"
          [isAddon]="isAddon"
          [marketingType]="marketingType"
          [personaType]="personaType"
          [orderForm]="orderForm"
          [usesActivationSpecificEntryUrl]="usesActivationSpecificEntryUrl"
          [fulfillmentOrderConfig]="fulfillmentOrderConfig"
          (addonSelected)="addonSelected.emit($event)"
          (editionTabSelected)="selectEditionTab($event)"
        ></store-product-info>
      </mat-tab>
      <mat-tab label="{{ 'FRONTEND.STORE.PRODUCT_DETAILS.TAB_LABELS.SCREENSHOTS_AND_FILES' | translate }}">
        <store-screenshots-files [app]="product"></store-screenshots-files>
      </mat-tab>
      @if (tabState.editionsTabVisible) {
        <mat-tab
          label="{{ 'FRONTEND.STORE.PRODUCT_DETAILS.TAB_LABELS.EDITIONS_AND_PRICING' | translate }}"
          >
          <ng-template matTabContent>
            <store-editions-marketing
              [contactSales]="product.shouldContactSales"
              [marketingType]="marketingType"
              [billingPrice]="billingPrice"
              [appPrice]="appPrice"
              [currency]="currency"
              [editionsMarketing]="editionsMarketing"
              [editionOrder]="editionOrder"
              [isEditionActionUsed]="isEditionActionUsed"
              (editionActionClick)="onEditionActionClicked($event)"
            ></store-editions-marketing>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>
  }
</div>
